import * as PathNavigation from '@site/components/PathNavigation'
import benefitsCuradoriaA from '@site/images/howItWorks/icon-benefits-curadoria-a.svg'
import benefitsCuradoriaB from '@site/images/howItWorks/icon-benefits-curadoria-b.svg'
import benefitsCuradoriaC from '@site/images/howItWorks/icon-benefits-curadoria-c.svg'
import benefitsCuradoriaD from '@site/images/howItWorks/icon-benefits-curadoria-d.svg'
import benefitsIneditosA from '@site/images/howItWorks/icon-benefits-ineditos-a.svg'
import benefitsIneditosB from '@site/images/howItWorks/icon-benefits-ineditos-b.svg'
import benefitsIneditosC from '@site/images/howItWorks/icon-benefits-ineditos-c.svg'
import benefitsIneditosD from '@site/images/howItWorks/icon-benefits-ineditos-d.svg'
import { clubCuradoriaData, clubIneditosData } from '@site/components/ClubSubscription/ClubSubscriptionData'

import { HowItWorks } from './HowItWorks'
import { Page } from './Pages'

export const HowItWorksTexts: Record<Page, HowItWorks | any> = {
  'home': null,
  'curadoria': ( subscriptionPlans?: any ): HowItWorks => ( {
    'buttonBenefitsText': 'Assinar TAG Curadoria',
    'buttonBenefitsUrl': `${PathNavigation.associese}&categoria=curadoria`,
    'column': [
      {
        'id': 1,
        'image': benefitsCuradoriaA,
        'imageAlt': 'Livros',
        'subtitle':
          'Preciosidades indicadas por grandes nomes da cultura nacional e internacional.',
        'title': 'Indicações singulares',
      },
      {
        'id': 2,
        'image': benefitsCuradoriaB,
        'imageAlt': 'Livro',
        'subtitle':
          'Clássicos ou contemporâneos, do Brasil ou do mundo. No clube Curadoria enviamos livros para que você explore e descubra o que há além da sua estante.',
        'title': 'Muito além da zona de conforto',
      },
      {
        'id': 3,
        'image': benefitsCuradoriaC,
        'imageAlt': 'Caixa',
        'subtitle':
          `Edições com projeto gráfico exclusivo em capa dura, mimo literário e revista sobre o autor e a obra a partir de ${clubCuradoriaData( subscriptionPlans ).prices.yearly} por mês.`,
        'title': 'Uma caixinha premium',
      },
      {
        'id': 4,
        'image': benefitsCuradoriaD,
        'imageAlt': 'Smartphone',
        'subtitle':
          'Você recebe acesso a um app exclusivo para registrar a leitura e conversar com outras pessoas associadas. E, a cada mês, novos vídeos e playlists temáticas, textos complementares e podcasts.',
        'title': 'Além da caixa',
      }
    ],
    'subtitle': [ 'TAG', ' Curadoria' ],
    'title': 'Como funciona?',
    'colorText': 'TAG1-700',
    'colorTextColumn': 'TAG1-700',
  } ),
  'ineditos': ( subscriptionPlans?: any ): HowItWorks => ( {
    'buttonBenefitsText': 'Assinar TAG Inéditos',
    'buttonBenefitsUrl': `${PathNavigation.associese}&categoria=ineditos`,
    'column': [
      {
        'id': 1,
        'image': benefitsIneditosA,
        'imageAlt': 'Livros',
        'subtitle':
          'O melhor da literatura contemporânea mundial lançada de forma inédita no Brasil em primeira mão aos associados.',
        'title': 'Best-sellers e grandes apostas',
      },
      {
        'id': 2,
        'image': benefitsIneditosB,
        'imageAlt': 'Livro',
        'subtitle':
          'Se você não dormir porque ficou pensando “só mais um capítulo”, não nos culpe depois!',
        'title': 'Você não vai conseguir parar de ler',
      },
      {
        'id': 3,
        'image': benefitsIneditosC,
        'imageAlt': 'Caixa',
        'subtitle':
          `Edições com projeto gráfico exclusivo em capa brochura, mimo literário e revista sobre o autor e a obra a partir de ${clubIneditosData( subscriptionPlans ).prices.yearly} por mês.`,
        'title': 'Exclusividade que cabe no seu bolso',
      },
      {
        'id': 4,
        'image': benefitsIneditosD,
        'imageAlt': 'Smartphone',
        'subtitle':
          'Você recebe acesso a um app exclusivo para registrar a leitura e conversar com outras pessoas associadas. E, a cada mês, novos vídeos e playlists temáticas, textos complementares e podcasts.',
        'title': 'Além da caixa',
      }
    ],
    'subtitle': [ 'TAG', ' Inéditos' ],
    'title': 'Como funciona?',
    'colorText': 'TAG2-700',
    'colorTextColumn': 'TAG2-650-TXT',
  } ),
}
